import { Dialog, Stack, Typography } from '@all-manager/design-system-v2';
import { formatDates } from '../../../../utils/formatValues';
import { useMeetingWarning } from './useMeetingWarning';

export function MeetingWarning() {
  const hook = useMeetingWarning();

  if (!hook.isOpen || !hook.meeting) {
    return null;
  }

  return (
    <Dialog
      open={hook.isOpen}
      onClose={hook.handleClose}
      maxWidth="sm"
      fullWidth
      title="Une réunion approche"
      closeLabel="Fermer"
      actions={{
        primaryAction: { label: "C'est noté", onClick: hook.handleClose },
        secondaryAction: { label: 'Voir les réunions', onClick: hook.handleSeeMeetings },
      }}
    >
      <Stack spacing={2}>
        <Typography variant="body1Emphasis">
          Prévue le {formatDates(hook.meeting.start_time, null)}
        </Typography>
        <Typography variant="body1">
          Une réunion est prévue dans moins de 15 jours. Pensez à vérifier l'ordre du jour et à préparer
          les points que vous souhaitez aborder.
        </Typography>
      </Stack>
    </Dialog>
  );
}
